import { Box, Button, Container, Typography } from '@mui/material';
import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <Box
      sx={{
        py: 10,
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 700,
            mb: 2,
          }}
        >
          Ready to Subscribe?
        </Typography>

        <SignedOut>
          <SignInButton mode="modal">
            <Button
              variant="contained"
              color="secondary"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Get Started for Free
            </Button>
          </SignInButton>
        </SignedOut>

        <SignedIn>
          <Link to="/app">
            <Button
              variant="contained"
              color="secondary"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Go to Group My Channels
            </Button>
          </Link>
        </SignedIn>
      </Container>
    </Box>
  );
};

export default CallToAction;
